module.exports = __webpack_public_path__ + "static/img/icon_googlepay.96c6b0d2.png";